import React from 'react';
import cn from 'clsx';

import { CircleXmarkRegularIcon } from '../../../../shared/icons/icons';
import Typography from '../../../typography/typography';
import { FilterChipValue } from '../../filter-chips';

import styles from './filter-chip.scss';

interface FilterChipProps extends FilterChipValue {
  onClick: ({ categoryCode, valueCode }) => void;
}

function FilterChip(props: FilterChipProps) {
  const { categoryCode, categoryName, onClick, valueCode, valueName } = props;

  return (
    <Typography
      aria-label={`remove ${valueName}`}
      className={cn(styles['container'], 'filter-chip')}
      onClick={() => onClick({ categoryCode, valueCode })}
      tag="button"
    >
      {categoryName}: {valueName}
      <CircleXmarkRegularIcon
        className={cn(styles['close-icon'], 'filter-chip__close-icon')}
      />
    </Typography>
  );
}

export default React.memo(FilterChip);
